"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contract = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var components_1 = require("../../../../shared/core/components");
var copy_1 = require("../../copy");
var PlanDetailsSummary_1 = require("../PlanDetailsSummary");
var StandingChargeSummary_1 = require("../StandingChargeSummary");
var UnitRateSummary_1 = require("../UnitRateSummary");
var Contract = function (_a) {
    var plan = _a.plan, fuelType = _a.fuelType;
    var _b = (0, core_1.useComponents)(), Heading4 = _b.Heading4, Stack = _b.Stack, Row = _b.Row, Col = _b.Col, Margin = _b.Margin;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var _c = core_1.configService.getConfig(), kapi = _c.kapi, region = _c.retailer.region;
    var kapiEnabled = region === 'UK' ? kapi && kapi.plan : true;
    var unitRates = plan.unitRates.map(function (rate) {
        return {
            timingCategory: plan.unitRates.length === 1 ? null : rate.timingCategory,
            rate: kapiEnabled
                ? rate.defaultRate.value
                : rate.unitRate.value,
            timePatternRegime: !kapiEnabled
                ? rate.timePatternRegime
                : undefined,
        };
    });
    return (react_1.default.createElement(components_1.MeterSummary, { "data-testid": "".concat(fuelType, "-contract"), fuel: fuelType },
        react_1.default.createElement(Margin, { top: 4 },
            react_1.default.createElement(Row, { isNested: true },
                react_1.default.createElement(Col, { large: 5 },
                    react_1.default.createElement(Heading4, { as: "h3" }, copy('contractDetails')),
                    react_1.default.createElement(PlanDetailsSummary_1.PlanDetailsSummary, { "data-testid": "plan-details-".concat(fuelType), contract: plan })),
                react_1.default.createElement(Col, { large: 7 },
                    react_1.default.createElement(Heading4, { as: "h3" }, copy('priceAndUnitRates')),
                    react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
                        react_1.default.createElement(StandingChargeSummary_1.StandingChargeSummary, { standingChargeValue: plan.standingCharge.value }),
                        react_1.default.createElement(UnitRateSummary_1.UnitRateSummary, { fuel: fuelType, unitRates: unitRates })))))));
};
exports.Contract = Contract;
